export default "/assets/images/peacekeeper-hero.png?6298efd011d729a05e4245ad1342b209";